import React from 'react';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    const baseClass = variant === 'outline' ? 'btn-outline' : 'btn-primary';

    return (
        <button
            className={`${baseClass} px-8 py-4 rounded-full text-sm font-bold uppercase tracking-widest ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
